module.exports = __webpack_public_path__ + "static/media/203-Verlassen_ID_1.5e3661fa.mp3";